import React from "react";
import { useTranslation } from "react-i18next";
import CsvImportPartner from "../Common/CsvImportPartner";
import XLSX from "xlsx";

const BulkImportPartnerStep1 = ({ setData, handleCancel, generalError }) => {
  const { t: translator } = useTranslation();

  const handleExport = () => {
    const itemsExample = [
      {
        id: "7a4492ce-b6b3-44a7-816f-6b2f1cf767d2",
        name: "Partner 3",
        taxNumber: "99957564535",
        description: "",
        street: "Kneza Trpimira",
        streetNumber: 1,
        streetNumberExtension: "A",
        city: "ZAGREB",
        postalNumber: "10000",
        country: "HRVATSKA",
        iban: "1234567891234567890",
        phone: "039399204",
        email: "test@test.com",
        branch: "001",
      },
      {
        id: "",
        name: "Partner 2",
        taxNumber: "03060717954",
        description: "",
        street: "Kneza Višeslava",
        streetNumber: 1,
        streetNumberExtension: "",
        city: "kom",
        postalNumber: "PDV 25",
        country: "Hrana",
        iban: "1234567891234567890",
        phone: "039399205",
        email: "test@test.com",
        branch: "002",
      },
    ];

    let wb = XLSX.utils.book_new();

    const wsItemsHeading = [
      [
        translator("Id"),
        translator("Naziv"),
        translator("Oib"),
        translator("Napomena"),
        translator("Ulica"),
        translator("Kućni broj"),
        translator("Dodatak kućnog broja"),
        translator("Grad"),
        translator("Poštanski broj"),
        translator("Država"),
        translator("IBAN"),
        translator("Telefon"),
        translator("Email"),
        translator("Branch"),
      ],
    ];
    let wsItems = XLSX.utils.aoa_to_sheet(wsItemsHeading);
    XLSX.utils.sheet_add_json(wsItems, itemsExample, {
      header: [
        "id",
        "name",
        "taxNumber",
        "description",
        "street",
        "streetNumber",
        "streetNumberExtension",
        "city",
        "postalNumber",
        "country",
        "iban",
        "phone",
        "email",
        "branch",
      ],
      skipHeader: true,
      origin: -1,
    });

    XLSX.utils.book_append_sheet(wb, wsItems, "Partneri");

    const fileName = "Partners.xlsx";
    XLSX.writeFile(wb, fileName);
  };

  return (
    <>
      <div>
        {translator("BulkImport-StepOne-PartnersText")}
        <table className="table table-striped mt-3">
          <thead>
            <tr>
              <td>{translator("BulkimportStep1-Name")}</td>
              <td>{translator("BulkimportStep1-Details")}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{translator("Naziv *")}</td>
              <td>{translator("Naziv partnera")}</td>
            </tr>
            <tr>
              <td>{translator("Oib *")}</td>
              <td>
                {translator(
                  "Podatak mora biti u pravilnom formatu i ne smije biti prazan."
                )}
              </td>
            </tr>
            <tr>
              <td>{translator("Napomena")}</td>
              <td>{translator("")}</td>
            </tr>
            <tr>
              <td>{translator("Ulica")}</td>
              <td>
                {translator(
                  "Naziv ulice bez kućnog broja, samo čisti naziv ulice. Npr. Ulica Kneza Trpimira."
                )}
              </td>
            </tr>
            <tr>
              <td>{translator("Kućni broj *")}</td>
              <td>
                {translator(
                  "Kućni broj može biti samo znamenka, bez dodataka, ako nema postaviti 0."
                )}
              </td>
            </tr>
            <tr>
              <td>{translator("Dodatak kućnom broju")}</td>
              <td>
                {translator(
                  "Dodatak kućnog broja je sve što je naknadno dodano iza kućnog broja,npr. bb,/2,A."
                )}
              </td>
            </tr>
            <tr>
              <td>{translator("Grad/Općina")}</td>
              <td>{translator("Naziv grada/općine")}</td>
            </tr>
            <tr>
              <td>{translator("Poštanski broj")}</td>
              <td>{translator("")}</td>
            </tr>
            <tr>
              <td>{translator("Država *")}</td>
              <td>{translator("Opcija: HRVATSKA")}</td>
            </tr>
            <tr>
              <td>{translator("IBAN")}</td>
              <td>{translator("Iban partnera, ostaviti prazno ako nema.")}</td>
            </tr>
            <tr>
              <td>{translator("Telefon")}</td>
              <td>{translator("Telefon, ostaviti prazno ako nema.")}</td>
            </tr>
            <tr>
              <td>{translator("Email")}</td>
              <td>{translator("Email, ostaviti prazno ako nema.")}</td>
            </tr>
          </tbody>
        </table>
        <div className="mt-3">
          <p>{translator("BulkImport-StepOne-RequiredData")}</p>
        </div>
        <div className="mt-3">
          <p>
            {translator("BulkImport-StepOne-ExampleText")}{" "}
            <a href="#" onClick={handleExport}>
              {translator("BulkImport-StepOne-Link-Here")}
            </a>
            .
          </p>
        </div>
        {generalError && (
          <div className="invalid-record mb-3 p-3">{generalError}</div>
        )}
        <CsvImportPartner setResult={setData} />
      </div>
      <div className="row mt-3">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
        </div>
      </div>
    </>
  );
};

export default BulkImportPartnerStep1;
